// Entry point for Trix/ActionText pages
import "trix";
import "@rails/actiontext";

Trix.config.blockAttributes.heading = {
    tagName: "h2",
    terminal: true,
    breakOnReturn: true,
    group: false,
};

Trix.config.blockAttributes.subHeading = {
    tagName: "h3",
    terminal: true,
    breakOnReturn: true,
    group: false,
};

Trix.config.lang = {
    bold: "Gras",
    bullets: "Liste",
    byte: "Octet",
    bytes: "Octets",
    captionPlaceholder: "Ajouter légende…",
    code: "Code",
    heading1: "Titre",
    indent: "Agrandir retrait",
    italic: "Italique",
    link: "Lien",
    numbers: "Liste numérotée",
    outdent: "Réduire retrait",
    quote: "Citation",
    redo: "Rétablir",
    remove: "Supprimer",
    strike: "Barré",
    undo: "Annuler",
    unlink: "Supprimer lien",
    url: "Lien",
    urlPlaceholder: "Saisir adresse URL…",
    GB: "Go",
    KB: "Ko",
    MB: "Mo",
    PB: "Po",
    TB: "To",
};